import AppBootstrapper from "@/config/bootstrapper";
AppBootstrapper.bootstrap();